import React, { Children } from 'react';
import PropTypes from 'prop-types';
import { css } from '@sitebase/emotion';
import { childrenOfType } from 'airbnb-prop-types';
import SelectOption from './SelectOption';

export var KEYCODES = {
  ENTER: 13,
  ESCAPE: 27,
  SPACE: 32,
  ARROW_LEFT: 37,
  ARROW_UP: 38,
  ARROW_RIGHT: 39,
  ARROW_DOWN: 40
};

export var GO = {
  UP: -1,
  DOWN: 1
};

export var renderNativeOptions = function renderNativeOptions(elements, labels) {
  return elements.map(function (child, idx) {
    return React.createElement(
      'option',
      { key: labels[idx], value: child.props.value, title: child.props.label },
      labels[idx]
    );
  });
};

export var findAnotherOption = function findAnotherOption(dir, start, childrenElements) {
  var findOption = function findOption(prevModifier) {
    var modifier = prevModifier + dir;
    var index = start + modifier;
    var child = childrenElements[index];

    if (child) {
      return child.props.disabled ? findOption(modifier) : index;
    }
    return start;
  };
  return findOption(0);
};

export var initiallySelectedIdx = function initiallySelectedIdx(childrenValues, value) {
  return childrenValues.indexOf((value || '').trim());
};

export var pickChildLabel = function pickChildLabel(child) {
  var optionProps = child.props;

  if (optionProps.label) return optionProps.label.trim();
  return typeof optionProps.children === 'string' ? optionProps.children.trim() : '';
};

export var pickChildValue = function pickChildValue(child) {
  var optionProps = child.props;

  if (optionProps.value != null) return optionProps.value.trim();
  if (typeof optionProps.children === 'string') return optionProps.children.trim();

  if (process.env.NODE_ENV !== 'production') {
    console.warn("<Select /> component couldn't get value for some option.", 'Use value property or string as children of <SelectOption />.');
  }
  return '';
};

export var splitToSelectEntries = function splitToSelectEntries(children) {
  var elements = [];
  var values = [];
  var labels = [];

  Children.forEach(children, function (child) {
    elements.push(child);
    values.push(pickChildValue(child));
    labels.push(pickChildLabel(child));
  });

  return {
    elements: elements,
    values: values,
    labels: labels
  };
};

export var cssSizes = {
  tiny: /*#__PURE__*/css('font-size:10px;height:28px;'),
  small: /*#__PURE__*/css('font-size:10px;height:28px;'),
  normal: /*#__PURE__*/css('height:36px;'),
  base: /*#__PURE__*/css('height:40px;'),
  large: /*#__PURE__*/css('height:46px;'),
  'x-large': /*#__PURE__*/css('height:56px;')
};

export var commonPropTypes = {
  className: PropTypes.string,
  id: PropTypes.string,
  name: PropTypes.string,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
  value: PropTypes.string,
  defaultValue: PropTypes.string,
  placeholder: PropTypes.string,
  children: childrenOfType(SelectOption),
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  onSubmit: PropTypes.func,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  onMouseMove: PropTypes.func,
  onMouseOut: PropTypes.func,
  onMouseOver: PropTypes.func,
  onMouseUp: PropTypes.func,
  theme: PropTypes.oneOf(['light', 'dark']).isRequired,
  size: PropTypes.string.isRequired,
  zIndex: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};